(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["globo-variant-image"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('stance-globo-gallery')) return;

  const normalize = value => String(value ?? '').normalize('NFKC').trim()
    .replace(/\s+/g, ' ').toLowerCase();

  const fieldAliases = { 'rim color': 'color' };
  const valueAliases = { 'rim color': { 'bronze': 'antique bronze' } };
  const controls = 'input[type="radio"], select:not([multiple])';

  const imagePath = source => {
    if (!source) return '';
    try {
      return new URL(source, location.origin).pathname.split('/').pop();
    } catch {
      return '';
    }
  };

  class StanceGloboGallery extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.revision = 0;
      this.optionNames = JSON.parse(this.dataset.optionNames).map(normalize);
      this.variants = JSON.parse(this.dataset.variants);

      const options = { capture: true, signal: this.abort.signal };

      document.addEventListener('change', event => this.handle(event), options);
      document.addEventListener('click', event => this.handle(event), options);

      for (const type of ['carousel:select', 'variant:change', 'product:rerender', 'click']) {
        document.addEventListener(type, event => {
          if (!(event.target instanceof Element)) return;

          const inGallery = this.activeGallery?.contains(event.target);
          const inProduct = this.activeGallery
            ?.closest('.shopify-section')?.contains(event.target);

          const navigation = type !== 'click' ||
            event.target.closest('.product-gallery__thumbnail, page-dots button');

          if (navigation && (inGallery || (type !== 'click' && inProduct))) {
            this.revision++;
            cancelAnimationFrame(this.frame);
            this.restore();
          }
        }, options);
      }
    }

    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
      this.revision++;
      this.restore();
    }

    restore() {
      if (!this.original) return;

      const { image, attributes } = this.original;

      for (const [name, value] of Object.entries(attributes)) {
        if (value === null) image.removeAttribute(name);
        else image.setAttribute(name, value);
      }

      this.original = null;
    }

    async showSwatch(control, gallery, revision) {
      const source = control.closest('.gpo-ov-item')
        ?.querySelector('img.swatch-image')?.getAttribute('src');

      if (!source) return;

      const url = new URL(source, location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return;

      for (const name of ['width', 'height', 'crop']) {
        url.searchParams.delete(name);
      }

      const preview = new Image();

      const loaded = new Promise(resolve => {
        preview.onload = () => resolve(true);
        preview.onerror = () => resolve(false);
      });

      preview.src = url.href;

      if (!await loaded || revision !== this.revision ||
          !gallery.isConnected || !this.isConnected) return;

      this.restore();

      const carousel = gallery.querySelector('media-carousel');
      const slides = [...carousel.children];
      let slide = carousel.selectedSlide || carousel.querySelector('.is-selected');

      if (!slide?.querySelector('img')) {
        slide = slides.find(item =>
          !item.hidden && item.matches('[data-media-type="image"]')
        );

        if (!slide) return;

        carousel.select(slides.indexOf(slide), {
          animate: false,
          force: true
        });
      }

      const image = slide.querySelector('img');

      const attributes = Object.fromEntries(
        ['src', 'srcset', 'sizes', 'alt', 'width', 'height', 'loading', 'style']
          .map(name => [name, image.getAttribute(name)])
      );

      this.original = { image, attributes };

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.setAttribute('src', url.href);
      image.setAttribute(
        'alt',
        `${control.getAttribute('data-field-name') || control.name}: ${control.value}`
      );
      image.setAttribute('width', preview.naturalWidth);
      image.setAttribute('height', preview.naturalHeight);
      image.setAttribute('loading', 'eager');
      image.style.objectFit = 'contain';
    }

    selection(control) {
      const field = normalize(
        control.getAttribute('data-field-name') ||
        control.name.replace(/^properties\[|\]$/g, '')
      );

      const optionIndex = this.optionNames.indexOf(fieldAliases[field] || field);
      const option = control.tagName === 'SELECT'
        ? control.selectedOptions[0]
        : control;

      if (!option || optionIndex < 0 || control.disabled) return null;
      if (control.type === 'radio' && !control.checked) return null;

      let value = normalize(option.getAttribute('original-value') ?? option.value);

      const exactValueExists = this.variants.some(variant =>
        normalize(variant.options[optionIndex]) === value
      );

      if (!exactValueExists) {
        value = valueAliases[field]?.[value] || value;
      }

      return value ? { optionIndex, value } : null;
    }

    findVariant(app, control) {
      if (!this.selection(control)) return null;

      const selections = [...app.querySelectorAll(controls)]
        .filter(item => !item.closest('[hidden], .gpo-hidden'))
        .map(item => this.selection(item))
        .filter(Boolean);

      const candidates = this.variants.filter(variant =>
        selections.every(selection =>
          normalize(variant.options[selection.optionIndex]) === selection.value
        )
      );

      if (!candidates.length ||
          candidates.some(variant => !variant.featured_image)) return null;

      const images = new Set(
        candidates.map(variant => imagePath(variant.featured_image.src))
      );

      return images.size === 1 ? candidates[0] : null;
    }

    handle(event) {
      if (!(event.target instanceof Element)) return;

      let control = event.target.closest('input, select, label');
      if (control?.tagName === 'LABEL') control = control.control;
      if (!control?.matches(controls)) return;

      const app = control.closest('.gpo-app');
      if (!app) return;

      const scope = control.closest('.shopify-section');

      const gallery = [...(scope?.querySelectorAll('product-gallery') || [])]
        .find(item =>
          item.getAttribute('form')
            ?.startsWith(`product-form-${this.dataset.productId}-`)
        );

      if (!gallery) return;

      this.activeGallery = gallery;
      const revision = ++this.revision;

      cancelAnimationFrame(this.frame);

      this.frame = requestAnimationFrame(async () => {
        if (!control.isConnected || !this.isConnected ||
            (control.type === 'radio' && !control.checked)) return;

        const variant = this.findVariant(app, control);

        await customElements.whenDefined('media-carousel');

        if (revision !== this.revision ||
            !gallery.isConnected || !this.isConnected) return;

        if (!variant) {
          await this.showSwatch(control, gallery, revision);
          return;
        }

        this.restore();

        for (const carousel of gallery.querySelectorAll('media-carousel')) {
          const slides = [...carousel.children]
            .filter(item => item.hasAttribute('data-media-id'));

          const mediaId = variant.featured_media?.id;
          const path = imagePath(variant.featured_image.src);

          const slide = slides.find(item =>
            mediaId && item.dataset.mediaId === String(mediaId)
          ) || slides.find(item =>
            imagePath(item.querySelector('img')?.getAttribute('src')) === path
          );

          if (!slide || slide.hidden ||
              typeof carousel.select !== 'function') continue;

          const index = [...(carousel.items || slides)].indexOf(slide);
          if (index < 0) continue;

          try {
            carousel.select(index, { animate: false, force: true });
          } catch (error) {
            console.warn('[Globo gallery] Could not select the product image.', error);
          }
        }
      });
    }
  }

  customElements.define('stance-globo-gallery', StanceGloboGallery);
})();
  } catch(e) { console.error(e); }
})();

})();
